import { CallToActionButton } from '@finn-no/troika-react-buttons';
import React, { useState } from 'react';
import * as S from './styles';
import FeedbackModal from './FeedbackModal';
import isDesktop from './isDesktop';
import { FeedbackType } from '../types';

type FeedbackProps = {
    url: string;
    type: import('../types').FeedbackType;
    addOnInfo?: string;
};

const Feedback: React.FC<FeedbackProps> = (props) => {
    const { url, type, ...passThroughProps } = props;
    const [completed, setCompleted] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const mobile = !isDesktop();

    return (
        <>
            {/* <S.Feedback className="ad-list-item" desktop={isDesktop()}> */}
            <S.Feedback className="ads__unit" desktop={isDesktop()}>
                <div className="panel panel--info u-ma0 u-pa8 u-r-size1of1">
                    <div className="u-display-block u-text-center">
                        <img
                            src="https://static.finncdn.no/_c/new-construction-podlet-assets/feedback/feedback-cat.svg"
                            alt="Bildet av Pusefinn"
                        />
                    </div>
                    <div className="u-ma8">
                        {!completed ? (
                            <>
                                {type === FeedbackType.Forhandler && (
                                    <p>
                                        Hei! Hva tenker du om anbefalingene du
                                        fikk på dette søket?
                                    </p>
                                )}
                                {type === FeedbackType.Keyword && (
                                    <p>
                                        Hei! Hva tenker du om anbefalingene du
                                        har fått her?
                                    </p>
                                )}

                                <CallToActionButton
                                    onClick={() => setIsOpen(true)}
                                    small={mobile}
                                    className="u-mt16 u-r-size1of1"
                                >
                                    Gi rask tilbakemelding
                                </CallToActionButton>
                            </>
                        ) : (
                            <>
                                <p>Takk!</p>
                                <p>
                                    Vi setter pris på din tilbakemelding - det
                                    hjelper oss med å bli bedre.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </S.Feedback>
            <FeedbackModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                completed={() => setCompleted(true)}
                url={url}
                type={type}
                {...passThroughProps}
            />
        </>
    );
};
export default Feedback;
